import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('cadastro', 'cache-manager');

const actions = {
  dropCache: { method: 'PUT', url: `${basePath}` },
};

export default resource => resource(`${basePath}`, {}, actions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/cache-manager.js